import { render, staticRenderFns } from "./Book.vue?vue&type=template&id=1178caa9&scoped=true"
import script from "./Book.vue?vue&type=script&lang=js"
export * from "./Book.vue?vue&type=script&lang=js"
import style0 from "./Book.vue?vue&type=style&index=0&id=1178caa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1178caa9",
  null
  
)

export default component.exports